<template>
  <div>
    <!--Charts-->
    <div class="row">
      <ListadoSiniestros :poliza="$route.params.id" :siniestro="$route.params.siniestro"></ListadoSiniestros>
    </div>
  </div>
</template>
<script>
import {ListadoSiniestros} from "@/components/index";

export default {
  components: {
    ListadoSiniestros
  },
  data() {
    return {};
  }
};
</script>
<style>
</style>
